import Arquivo from "model/arquivo/Arquivo";
import Viagem from "./Viagem";
import ViagemTipoDespesa from "./ViagemTipoDespesa";

export default class ViagemDespesaPrevista {
    id: number | null;
    key: string = "";
	sequencial: number = 0;
    viagem: Viagem | null;
    tipo: ViagemTipoDespesa | null;
    observacao: string;
    formaPagamento: "DINHEIRO" | "CREDITO" | "PAGAMENTO_ANTECIPADO" | null;
    imagens: Arquivo[];
    valor: number;

    constructor(
        id = null,
        viagem : Viagem | null = null,
        tipo = null,
        observacao = '',
        formaPagamento = null,
        imagens: Arquivo[] = [],
        valor = 0,
    ) {
        this.id = id;
        this.viagem = viagem;
        this.tipo = tipo;
        this.observacao = observacao;
        this.formaPagamento = formaPagamento;
        this.imagens = imagens;
        this.valor = valor;
    }

}